module.exports = __webpack_public_path__ + "img/paihang.9c80f16c.png";